import classNames from "classnames";

export const iconClasses = classNames("tw-h-5", "tw-w-5");
export const smallIconClasses = classNames("tw-h-4", "tw-w-4");

export const sizedIconClasses = (
  size: "small" | "medium" | "large" | "largeTallOnMobile",
) =>
  size === "large" || size === "medium" || size === "largeTallOnMobile"
    ? iconClasses
    : smallIconClasses;

export const tooltipIconClasses = classNames(
  "tw-mt-px tw-size-5 tw-cursor-pointer tw-fill-fay-500 tw-stroke-fay-500",
);
